<template>
  <!-- 客户和客户负责人(화주-조장 담당) 관리(2026-10-18 崔凡 #81) — 货主를 여러 개 골라 组长负责人을 한번에 배정(批量添加)한다.
       订单列表·入仓登记 가 이 표를 읽어 «组长负责人» 로 보여 준다. 표에 없는 货主는 «等待分配组长» -->
  <div class="container-fluid olm">
    <b-card no-body class="mb-3">
      <b-card-body>
        <h5 class="mb-3">客户和客户负责人<small class="text-muted ml-1">(화주 ↔ 조장 담당)</small></h5>
        <div class="d-flex flex-wrap align-items-center mb-2" style="gap:8px">
          <label class="mb-0 font-weight-bold">组长负责人<small>(조장 이름)</small></label>
          <input v-model.trim="leader" list="olmLeaderList" class="form-control form-control-sm" style="width:180px" placeholder="例: 孙明慧" maxlength="30">
          <datalist id="olmLeaderList"><option v-for="l in leaderNames" :key="l" :value="l"></option></datalist>
          <b-button size="sm" variant="primary" :disabled="saving || !leader || !picked.length" @click="assign">
            <b-spinner v-if="saving" small></b-spinner> 批量添加<small>(고른 {{ picked.length }}개 货主에 배정)</small>
          </b-button>
          <b-button size="sm" variant="outline-danger" :disabled="saving || !pickedMapped.length" @click="removePicked">
            取消分配<small>(고른 것 중 배정된 {{ pickedMapped.length }}개 해제)</small>
          </b-button>
          <span class="small text-muted">共 {{ companies.length }}个货主 · 已分配 {{ mappedCount }} · <b class="text-danger">等待分配组长 {{ companies.length - mappedCount }}</b></span>
        </div>
        <div class="d-flex flex-wrap align-items-center" style="gap:8px">
          <input v-model.trim="q" class="form-control form-control-sm" style="width:200px" placeholder="搜索货主(화주 검색)">
          <select v-model="filter" class="form-control form-control-sm" style="width:170px">
            <option value="">全部(전체)</option>
            <option value="none">等待分配组长(미배정만)</option>
            <option value="mapped">已分配(배정됨만)</option>
          </select>
          <select v-model="filterLeader" class="form-control form-control-sm" style="width:150px">
            <option value="">所有组长(전체 조장)</option>
            <option v-for="l in leaderNames" :key="'fl' + l" :value="l">{{ l }}</option>
          </select>
          <b-button size="sm" variant="outline-secondary" @click="pickAllShown">全选当前<small>(보이는 것 전체 선택)</small></b-button>
          <b-button size="sm" variant="outline-secondary" @click="picked = []">取消选择<small>(선택 해제)</small></b-button>
          <b-button size="sm" variant="outline-primary" :disabled="loading" @click="load">刷新<small>(새로고침)</small></b-button>
        </div>
        <div class="d-flex flex-wrap align-items-center mt-2" style="gap:8px">
          <input v-model.trim="addText" class="form-control form-control-sm" style="width:260px" placeholder="手动添加货主(목록에 없는 화주 직접 추가)" @keyup.enter="addManual">
          <b-button size="sm" variant="outline-secondary" :disabled="!addText" @click="addManual">添加到列表<small>(목록에 추가)</small></b-button>
        </div>
        <div class="mt-2">
          <b-button size="sm" variant="outline-primary" @click="pasteOpen = !pasteOpen">{{ pasteOpen ? '收起' : '粘贴批量分配' }}<small>(엑셀에서 붙여넣어 한꺼번에 배정)</small></b-button>
          <div v-if="pasteOpen" class="mt-2">
            <div class="small text-muted mb-1">每行一个货主: 「货主 ⇥ 组长」(从Excel两列直接复制), 或只写货主(使用上面「组长负责人」输入框的名字)。 (한 줄에 화주 하나: «화주 ⇥ 조장» 엑셀 두 열 복사, 또는 화주만 쓰면 위 조장 칸 이름으로 배정)</div>
            <textarea v-model="pasteText" class="form-control form-control-sm" rows="6" style="max-width:520px" placeholder="货主A&#9;孙明慧&#10;货主B&#9;张浩"></textarea>
            <div class="mt-1 d-flex align-items-center" style="gap:8px">
              <b-button size="sm" variant="primary" :disabled="saving || !pasteParsed.rows.length" @click="assignPasted">
                <b-spinner v-if="saving" small></b-spinner> 分配 {{ pasteParsed.rows.length }}个货主
              </b-button>
              <span class="small text-muted">{{ pasteParsed.leaders.length }}位组长</span>
              <span v-if="pasteParsed.bad" class="small text-danger">{{ pasteParsed.bad }}行缺少组长(조장 없는 줄 {{ pasteParsed.bad }}개는 제외)</span>
            </div>
          </div>
        </div>
        <div v-if="error" class="small text-danger mt-2">{{ error }}</div>
      </b-card-body>
    </b-card>

    <div class="table-responsive bg-white olm__table">
      <table class="table table-sm table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th style="width:36px"><input type="checkbox" :checked="allShownPicked" @change="toggleAllShown($event.target.checked)"></th>
            <th>货主<small>(화주)</small></th>
            <th>组长负责人<small>(조장)</small></th>
            <th>最近修改<small>(최근 수정)</small></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in shown" :key="c.companyid" :class="{ 'table-warning': !c.leader }">
            <td><input v-model="picked" type="checkbox" :value="c.companyid"></td>
            <td class="font-weight-bold">{{ c.companyid }}</td>
            <td>
              <b-badge v-if="c.leader" variant="info" class="px-2 py-1" style="font-size:13px">{{ c.leader }}</b-badge>
              <span v-else class="text-danger">等待分配组长<small>(조장 배정 대기)</small></span>
            </td>
            <td class="small text-muted">{{ c.updatedAt ? fmt(c.updatedAt) : '' }} {{ c.updatedBy }}</td>
          </tr>
          <tr v-if="!shown.length && !loading"><td colspan="4" class="text-center text-muted py-4">暂无数据(데이터 없음)</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OwnerLeaderManage',
  data() {
    return { loading: false, saving: false, error: '', leader: '', q: '', filter: '', filterLeader: '', addText: '', pasteOpen: false, pasteText: '', allCompanies: [], map: {}, meta: {}, picked: [], extra: [] };
  },
  computed: {
    companies() {
      return [...new Set(this.allCompanies.concat(Object.keys(this.map), this.extra))].sort((a, b) => a.localeCompare(b));
    },
    rows() {
      return this.companies.map(companyid => ({ companyid, leader: this.map[companyid] || '', updatedAt: (this.meta[companyid] || {}).updatedAt, updatedBy: (this.meta[companyid] || {}).updatedBy || '' }));
    },
    leaderNames() {
      return [...new Set(Object.values(this.map))].sort((a, b) => a.localeCompare(b));
    },
    mappedCount() {
      return this.rows.filter(r => r.leader).length;
    },
    shown() {
      const k = this.q.toLowerCase();
      return this.rows.filter(r => (!k || r.companyid.toLowerCase().includes(k) || r.leader.toLowerCase().includes(k)) &&
        (!this.filter || (this.filter === 'none' ? !r.leader : !!r.leader)) &&
        (!this.filterLeader || r.leader === this.filterLeader));
    },
    // 붙여넣은 줄 풀이 — «화주 ⇥ 조장» / «화주» (조장은 위 입력칸)
    pasteParsed() {
      const rows = [];
      let bad = 0;
      this.pasteText.split(/\r?\n/).forEach(line => {
        const parts = line.split(/[\t,，]+/).map(x => x.trim()).filter(Boolean);
        if (!parts.length) return;
        const owner = parts[0];
        const leader = (parts[1] || this.leader || '').slice(0, 30);
        if (!leader) { bad++; return; }
        rows.push({ owner, leader });
      });
      return { rows, bad, leaders: [...new Set(rows.map(r => r.leader))] };
    },
    allShownPicked() {
      return this.shown.length > 0 && this.shown.every(r => this.picked.includes(r.companyid));
    },
    pickedMapped() {
      return this.picked.filter(id => this.map[id]);
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    fmt(v) {
      const d = new Date(v);
      return isNaN(d.getTime()) ? '' : d.toLocaleString('zh-CN', { hour12: false });
    },
    async load() {
      this.loading = true;
      this.error = '';
      try {
        // 货主 목록 = 쿠패스 화주(auth.showimport) — 营业执照管理 와 같은 기준 + 이미 배정된 货主
        const [users, mp] = await Promise.all([axios.post('/api/getcompanyids', {}), axios.post('/api/ownerLeader/map', {})]);
        const list = (users.data && users.data.result) || [];
        this.allCompanies = [...new Set(list.filter(u => u.auth && u.auth.showimport).map(u => u.companyid).filter(Boolean))];
        if (mp.data.요청결과 !== '성공') throw new Error((mp.data.error && mp.data.error.errorMessage) || '读取失败');
        this.map = mp.data.map || {};
        const meta = {};
        (mp.data.rows || []).forEach(r => { meta[r.companyid] = { updatedAt: r.updatedAt, updatedBy: r.updatedBy }; });
        this.meta = meta;
      } catch (e) {
        console.error('货主-组长 목록 오류:', e);
        this.error = '加载失败(불러오기 실패): ' + e.message;
      } finally {
        this.loading = false;
      }
    },
    toggleAllShown(v) {
      const ids = new Set(this.picked);
      this.shown.forEach(r => { if (v) ids.add(r.companyid); else ids.delete(r.companyid); });
      this.picked = [...ids];
    },
    pickAllShown() {
      this.toggleAllShown(true);
    },
    addManual() {
      const id = this.addText.trim();
      if (!id) return;
      if (!this.extra.includes(id)) this.extra = this.extra.concat(id);
      if (!this.picked.includes(id)) this.picked = this.picked.concat(id);
      this.addText = '';
    },
    async assign() {
      if (!this.leader || !this.picked.length) return;
      this.saving = true;
      this.error = '';
      try {
        const { data } = await axios.post('/api/ownerLeader/save', { leader: this.leader, companyids: this.picked });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        this.$bvToast.toast('已分配 ' + data.saved + '个货主', { title: '组长负责人', variant: 'success', solid: true, autoHideDelay: 1800 });
        this.picked = [];
        await this.load();
      } catch (e) {
        console.error('组长 배정 오류:', e);
        this.error = '保存失败(저장 실패): ' + e.message;
      } finally {
        this.saving = false;
      }
    },
    async assignPasted() {
      const { rows } = this.pasteParsed;
      if (!rows.length) return;
      this.saving = true;
      this.error = '';
      try {
        const by = {};
        rows.forEach(r => { (by[r.leader] = by[r.leader] || new Set()).add(r.owner); });
        let saved = 0;
        for (const leader of Object.keys(by)) {
          const ids = [...by[leader]];
          for (let i = 0; i < ids.length; i += 500) {
            const { data } = await axios.post('/api/ownerLeader/save', { leader, companyids: ids.slice(i, i + 500) });
            if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
            saved += data.saved || 0;
          }
        }
        this.$bvToast.toast('已分配 ' + saved + '个货主', { title: '组长负责人', variant: 'success', solid: true, autoHideDelay: 2200 });
        this.pasteText = '';
        await this.load();
      } catch (e) {
        console.error('붙여넣기 배정 오류:', e);
        this.error = '保存失败(저장 실패): ' + e.message;
      } finally {
        this.saving = false;
      }
    },
    async removePicked() {
      if (!this.pickedMapped.length) return;
      if (!confirm('取消 ' + this.pickedMapped.length + '个货主的组长分配? (' + this.pickedMapped.length + '개 화주의 조장 배정을 해제합니다)')) return;
      this.saving = true;
      try {
        const { data } = await axios.post('/api/ownerLeader/remove', { companyids: this.pickedMapped });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '失败');
        this.picked = [];
        await this.load();
      } catch (e) {
        console.error('组长 해제 오류:', e);
        this.error = '操作失败(실패): ' + e.message;
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.olm small { margin-left: 3px; opacity: .75; }
.olm__table { max-height: calc(100vh - 300px); overflow: auto; }
.olm__table thead th { position: sticky; top: 0; z-index: 1; }
</style>
